import { PROJECT } from "@/data/project";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[var(--co-primary-deep)] text-white pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-3 gap-10 pb-10 border-b border-white/10">
          <div>
            <p className="font-display font-extrabold text-2xl tracking-tight">
              COSTA OESTE <span className="text-[var(--co-accent-light)]">PLAZA</span>
            </p>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">
              El epicentro comercial de La Chorrera. Apertura {PROJECT.year}.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-[var(--co-accent-light)] font-semibold">
              Contacto
            </p>
            <ul className="mt-4 space-y-2 text-white/70 text-sm">
              <li>{PROJECT.contact.phone}</li>
              <li className="break-all">{PROJECT.contact.email}</li>
              <li>{PROJECT.contact.address}</li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-[var(--co-accent-light)] font-semibold">
              Desarrollado por
            </p>
            <p className="mt-4 font-display font-bold text-xl">{PROJECT.developer}</p>
            <p className="mt-2 text-white/60 text-sm">
              Más de dos décadas creando bienes raíces en Panamá.
            </p>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} {PROJECT.developer}. Todos los derechos reservados.</p>
          <p>Costa Oeste Plaza · La Chorrera, Panamá Oeste</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
